import React from 'react';

import {
  Box,
  InputAdornment,
  Slider,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

export interface IndicatorValueUnit {
  code?: string;
  name?: string;
  symbol?: string;
  minimum?: number | null;
  maximum?: number | null;
  step?: number | null;
  bounded?: boolean;
}

type Props={
  label:string;
  helperText:string;
  value:number|string;
  onChange:(value:number|string)=>void;
  unit?:IndicatorValueUnit|null;
  nullable?:boolean;
  recommended?:boolean;
};

const upper=(value:any)=>String(value??'').trim().toUpperCase();

const isPercentage=(unit?:IndicatorValueUnit|null)=>{
  const token=[
    unit?.code,
    unit?.name,
    unit?.symbol,
  ].map(upper).join(' ');

  return (
    token.includes('PERCENT')
    ||token.includes('POURCENT')
    ||token.includes('TAUX')
    ||token.includes('%')
  );
};

const resolveBounds=(unit?:IndicatorValueUnit|null)=>{
  if(
    unit?.minimum!==null
    &&unit?.minimum!==undefined
    &&unit?.maximum!==null
    &&unit?.maximum!==undefined
    &&Number(unit.maximum)>Number(unit.minimum)
  ){
    return {
      min:Number(unit.minimum),
      max:Number(unit.maximum),
      step:Number(unit.step??1),
      bounded:true,
    };
  }

  if(isPercentage(unit)){
    return {
      min:0,
      max:100,
      step:Number(unit?.step??0.1),
      bounded:true,
    };
  }

  return {
    min:0,
    max:100,
    step:Number(unit?.step??1),
    bounded:false,
  };
};

export default class IndicatorValueEditor
extends React.PureComponent<Props>{

  render(){
    const {
      label,
      helperText,
      value,
      onChange,
      unit,
      nullable=false,
      recommended=false,
    }=this.props;

    const bounds=resolveBounds(unit);
    const numericValue=
      value===''||value===null||value===undefined
        ?0
        :Number(value);

    const suffix=
      unit?.symbol
      ||unit?.code
      ||'';

    return (
      <Box>
        <TextField
          fullWidth
          type="number"
          label={label}
          value={value}
          onChange={event=>{
            const next=event.target.value;

            onChange(
              nullable&&next===''
                ?''
                :Number(next||0),
            );
          }}
          helperText={
            recommended
              ?`${helperText} Recommended value — confirm or adjust.`
              :helperText
          }
          slotProps={{
            input:{
              endAdornment:suffix
                ?(
                  <InputAdornment position="end">
                    {suffix}
                  </InputAdornment>
                )
                :undefined,
            },
          }}
        />

        {bounds.bounded&&(
          <Stack spacing={0.25} sx={{px:1,pt:1}}>
            <Slider
              value={numericValue}
              min={bounds.min}
              max={bounds.max}
              step={bounds.step}
              valueLabelDisplay="auto"
              valueLabelFormat={sliderValue=>
                `${sliderValue}${suffix?` ${suffix}`:''}`
              }
              onChange={(_,next)=>
                onChange(
                  Array.isArray(next)
                    ?Number(next[0])
                    :Number(next),
                )
              }
            />

            <Stack
              direction="row"
              justifyContent="space-between"
            >
              <Typography variant="caption" color="text.secondary">
                {bounds.min}{suffix?` ${suffix}`:''}
              </Typography>

              <Typography variant="caption" color="text.secondary">
                {bounds.max}{suffix?` ${suffix}`:''}
              </Typography>
            </Stack>
          </Stack>
        )}
      </Box>
    );
  }
}
